import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { ConstantsService } from './constants.service';
import { from, map, mergeMap, switchMap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DatasearchBetaNewService {
  readonly ApiUrl: string = environment.appUrl;

  constructor(private http: HttpClient, public constants: ConstantsService) { }

  // Get Table COlumn Values Dynamically
  GetDropDownValues(postdata:any)
  {
    return this.http.post<any>(this.constants.ApiUrl+'/get_dropdownvalues',postdata).pipe(
      map((response:any)=>{
        return response;
      })
    );
  }

  // Get Table COlumn Values Dynamically
  GetChemroboticsData(postdata:any)
  {
    return this.http.post(this.constants.ApiUrl+'/get_chemroboticsdata',postdata);
  
  }
// Send contact us request
sendInquiryForm(postdata: any) {
  return this.http.post<any>(this.ApiUrl +'/user-query',postdata);
}
getPdfs(){
  return this.http.get<any>(this.ApiUrl +'/get-agro-service-pdf');
}
// Get patends-india
getPatents() {
  return this.http.get<any>(this.ApiUrl + '/get-patends-india');
}
// Get team members
getAllHeadings() {
  return this.http.get<any>(this.ApiUrl + '/get-page-headers');
}
  // Get columns from Template
  GetTemplateCols()
  {
    return this.http.get<any>(this.constants.ApiUrl+'/api/v2/ipd/columns');
  
  }

  sendMail(postdata:any) {
    return this.http.post(this.constants.ApiUrl + '/sendmail', postdata);
  }

  sendMailNew(postdata: any) {
    return this.http.post(this.constants.ApiUrl + '/sendmail-new', postdata);
  }

  userMasterManage(postdata:any) {
    return this.http.post(
      this.constants.ApiUrl + '/usermaster_manage',
      postdata
    );
  }

  quik_patent_manage(postdata:any)
  {
    return this.http.post<any>(this.constants.ApiUrl+'/quik-patent',postdata);
  
  }

  // Get dropdown values quik patent
  quik_patent_dropdown(postdata:any)
  {
    return this.http.post<any>(this.constants.ApiUrl+'/quik-patent-dropdown-values',postdata);  
  }

  // Get combination dropdown values quik patent
  quik_patent_combination_dropdown(postdata:any)
  {
    return this.http.post<any>(this.constants.ApiUrl+'/quik-patent-combination-dropdown-values',postdata);  
  }

  // Get column config quik patent
  quik_patent_column_config(postdata:any)
  {
    return this.http.post<any>(this.constants.ApiUrl+'/quik-patent-column-config',postdata);  
  }

  // Save column config quik patent
  save_quik_patent_column_config(postdata:any)
  {
    return this.http.post<any>(this.constants.ApiUrl+'/quik-patent-column-config-save',postdata);  
  }

  // Get quik patent data
  quik_patent_data(postdata:any){
    return this.http.post<any>(this.constants.ApiUrl+'/quik-patent-data',postdata);  
  }

  // Get quik patent month chart data
  quik_patent_month_chart_data(postdata:any){
    return this.http.post<any>(this.constants.ApiUrl+'/quik-patent-month-chart',postdata); 
  }

  // Get quik patent year chart data
  quik_patent_year_chart_data(postdata:any){
    return this.http.post<any>(this.constants.ApiUrl+'/quik-patent-year-chart',postdata); 
  }

  // Get quik patent assignee year data
  quik_patent_assignee_year_data(postdata:any){
    return this.http.post<any>(this.constants.ApiUrl+'/quik-patent-assignee-year', postdata); 
  }

  // Get quik patent assignee month data
  quik_patent_assignee_month_data(postdata:any){
    return this.http.post<any>(this.constants.ApiUrl+'/quik-patent-assignee-month',postdata); 
  }

  // Get applicants data
  get_applicants_data(postdata:any){
    return this.http.post<any>(this.constants.ApiUrl+'/get-applicants-open',postdata); 
  }

  // Get quik patent datacount
  quik_patent_data_count(postdata:any)
  {
    return this.http.post<any>(this.constants.ApiUrl+'/quik-patent-data-count',postdata);  
  }

  // Get quik analysis
  quik_patent_analysis(postdata:any)
  {
    return this.http.post<any>(this.constants.ApiUrl+'/quik-patent-analysis',postdata);  
  }

  // Get Keyword list
  getKeywordList(postdata:any){
    return this.http.post<any>(this.constants.ApiUrl+'/get-keyword',postdata);  
  }
  
  // Get News Data getNewsData
  getNewsData(postdata:any){
    return this.http.post<any>(this.constants.ApiUrl+'/get-news-data-open',postdata);
  }

  // Get News Category Details Data
  getNewsCatDetData(postdata:any){
    return this.http.post<any>(this.constants.ApiUrl+'/get-news-cat-det-open',postdata);
  }

  // Get News List Open
  getNewsList(postdata:any){
    return this.http.post<any>(this.constants.ApiUrl+'/get-news-list-open',postdata);
  }

  // Get Recent News Open
  getRecentNews(postdata:any){
    return this.http.post<any>(this.constants.ApiUrl+'/get-recent-news-open',postdata);
  }

  // Get News Category Details
  getNewsCategoryDetails(postdata:any){
    return this.http.post<any>(this.constants.ApiUrl+'/get-news-category-details',postdata);
  }
// Get user profession
getUserprofession() {
  return this.http.get<any>('https://www.chemrobotics.com/staging/UserLoginController/get_scientific_professions');
}
  // Get News Details
  getNewsDetails(postdata:any){
    return this.http.post<any>(this.constants.ApiUrl+'/get-news-details',postdata);
  }

  // Get Related News
  getRelatedNews(postdata:any){
    return this.http.post<any>(this.constants.ApiUrl+'/get-related-news',postdata);
  }

  Get_Template_Tables_mongo() {
    return this.http.post(`${this.constants.ApiUrl}/get_tables_mongo`,"test");
  }

  // Get label
  getlabel(postdata:any){
    return this.http.post<any>(this.constants.ApiUrl+'/get-label',postdata);
  }

  // agro_jarvis_manage(postdata:any)
  // {
  //   return this.http.post<any>(this.constants.ApiUrl+'/agro_jarvis',postdata);
  
  // }

  //Get Template Table Details
  GetTemplateTableDtls(postdata:any) {
    return this.http.post<any>(
      this.constants.ApiUrl + '/get_tabledtls_mongo',
      postdata
    );
  }

  //chart data

  getChartData(postdata:any){
    return this.http.post<any>(this.constants.ApiUrl+'/api/v2/ipd/graph-data',postdata);
  }

  // Demo Request
  demoRequest(postdata:any){
    return this.http.post<any>(this.constants.ApiUrl+'/demo-request',postdata);
  }
  // Post career jobs
getFooter() {
  return this.http.get<any>(this.constants.ApiUrl + '/api/v2/footer');
}
// Post career jobs
getHeader() {
  return this.http.get<any>(this.constants.ApiUrl + '/api/v2/header');
}
// get brochure
getBrochure() {
  return this.http.get<any>(this.constants.ApiUrl + '/api/v2/brochure');
}
// post demo request
sendSignup(postdata: any) {
  return this.http.post<any>('https://www.chemrobotics.com/staging/UserLoginController/register_new_user', postdata);
}
  // changeDataType(postdata) {
  //   return this.http.post<any>(
  //     this.constants.ApiUrl + '/change-data-type',
  //     postdata
  //   );
  // }
// Send change password request
sendForgotpswd(formData: FormData) {
  return this.http.post<any>('https://www.chemrobotics.com/staging//UserLoginController/forgot_password', formData);
}

  getIpandLocation() {

    const observable_ip = from(fetch(`https://backend.chemrobotics.com/get-user-ip`)).pipe(
        switchMap((response) => response.json())
      );

      return observable_ip.pipe(
        mergeMap(res => 
          from(fetch(`https://ipapi.co/${res.ip}/json/`)).pipe(
          switchMap((response) => response.json())
        )
        )
      ).pipe(
        map(res=> {
          return {userip:res.ip,address: `${res.city} ${res.region} ${res.country_name}`}
        })
      )
    
  }
}
